<template>
    <div class="card__body">
      <slot />
    </div>
</template>

<script>



export default {
  name: 's-card-body',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
